import { MainNavigation } from "melco-ui";

import Logo from "../../assets/logo.svg";
import LogoCollapsed from "../../assets/logo_collapsed.svg";
import { MainMenu } from "./MainMenu";

export const EFSMainNavigation: React.FC = () => {
  return (
    <MainNavigation
      appName="EFS"
      logo={Logo}
      logoCollapsed={LogoCollapsed}
      mainMenu={<MainMenu />}
    />
  );
};
